module.exports = __webpack_public_path__ + "static/genie-in-appb-e5e1080f37d7beebf745fbe4705e20c7.png";